import React, { useEffect } from "react";

export default function HomePage() {

  document.title = "Welcome"

  useEffect(() => {

    window.location.replace("https://discord.com/oauth2/authorize?client_id=491628430748680193");

  }, [])

  return <></>;

}